/** Buddy companion lines — calm, supportive, neurodiverse-friendly */
export const BUDDY_MESSAGES: readonly string[] = [
  "You're doing great. Want to take a calm breath together?",
  "It's okay to go slowly today — your pace is perfect.",
  "I noticed you tried hard. That matters more than the score.",
  "Let's pause for a moment and notice something kind around you.",
  "Your feelings are welcome here, every single one of them.",
  "Small steps still move you forward. I'm proud of you.",
  "Would you like a quiet minute before we continue?",
  "You don't have to be perfect to be amazing.",
  "I think a gentle stretch might feel nice right now.",
  "Remember: rest is part of learning, not the opposite of it.",
  "You showed up today. That already counts as brave.",
  "Let's celebrate one thing that went well, however small.",
  "It's fine if your brain needs a different path today.",
  "I'm here with you — no rush, no pressure.",
  "Your curiosity is one of your superpowers.",
  "Want to pick a calm sound while we think together?",
  "Big feelings are allowed. We can hold them gently.",
  "You asked a great question. Let's explore it slowly.",
  "Tomorrow is a fresh page. Tonight can be soft.",
  "I like how carefully you listened just now.",
  "Focus can come in waves. We'll ride this one together.",
  "A deep breath in… and a slow breath out. Well done.",
  "You matter exactly as you are, right in this moment.",
  "Let's turn down the noise and turn up the kindness.",
  "Progress isn't always loud. Yours is still real.",
  "Would a two-minute break help your mind feel clearer?",
  "I believe in you — especially on the tricky days.",
  "Your imagination just lit up. Tell me more when you're ready.",
  "We can try again later. No disappointment here.",
  "Sensory breaks are smart, not silly. Want one?",
  "You handled that change better than you think.",
  "Let's name three things that feel safe right now.",
  "Gentle effort beats frantic hustle every time.",
  "I'm cheering for you quietly from right here.",
  "Your brain works beautifully in its own way.",
  "It's okay to say 'not yet' instead of 'never'.",
  "A little movement might help — wiggle, stretch, or sway.",
  "You deserve credit for trying, not just for winning.",
  "Let's make the next step small enough to feel easy.",
  "Quiet courage is still courage. I see yours.",
  "Want to doodle or hum while we plan the next bit?",
  "You're allowed to change your mind. That's growth.",
  "I noticed you being kind to someone. That shines.",
  "Overwhelm passes. We'll wait it out side by side.",
  "Your calm place is always one breath away.",
  "Learning looks different for every mind — including yours.",
  "Let's end this moment with something that makes you smile.",
  "You are not alone in this room or in this app.",
  "Ready when you are. I'll match your speed.",
  "That was enough for today. Honestly, enough.",
  "Your effort today planted something good. Trust that.",
  "Let's lower the volume on worry and raise self-kindness.",
  "One kind thought about yourself counts as homework done.",
  "Brains get tired too. Yours earned a soft landing.",
  "You can ask for help. That's wisdom, not weakness.",
  "I saved a high-five for you — here it is.",
  "Mistakes are data, not disasters. We learn gently.",
  "Your pace protects your peace. Keep it.",
  "Let's find one colour in the room that feels friendly.",
  "You survived every hard minute so far. That's a streak.",
  "Comfort first, then curiosity. Always that order.",
  "I like the way your mind connects unexpected dots.",
  "Silence can be cozy. We don't have to fill it.",
  "You're growing in directions tests can't always measure.",
  "Want to count four slow breaths with me?",
  "Your 'almost' is still progress worth honouring.",
  "Kindness to yourself is a skill you're practising.",
  "Today can be low-key and still be meaningful.",
  "I'll wait while you grab water or wiggle free.",
  "You don't owe anyone a performance right now.",
  "Let's shrink the task until it fits in your hands.",
  "Your nervous system is doing its best. So are you.",
  "I heard patience in your voice just then. Beautiful.",
  "Joy can be tiny — a joke, a pet, a sunny patch.",
  "You're allowed to unplug and come back softer.",
  "We can label the feeling without letting it drive.",
  "Your questions make the world more interesting.",
  "Gentle routines are anchors on wavy days.",
  "I trust you to know when to push and when to rest.",
  "Let's notice one sound that feels neutral or nice.",
  "You turned up for yourself. That is radical care.",
  "Comparison steals sparkle. Let's keep yours.",
  "A messy try beats a perfect never-start.",
  "Your body deserves comfort, not criticism.",
  "We can celebrate 'done enough' instead of 'done perfectly'.",
  "I'm holding space while you find your words.",
  "You are learning how you learn. That's meta-magic.",
  "Let's pair this task with something that feels safe.",
  "Your timeline is valid even if it looks different.",
  "Brave can mean whispering 'I need a break'.",
  "I see resilience in how you kept going.",
  "Want to imagine a cozy blanket around your shoulders?",
  "You can start over without starting from zero.",
  "Your laugh just now was medicine. More welcome anytime.",
  "Let's trade 'should' for 'could' for a minute.",
  "You are more than your hardest moment today.",
  "Grounding trick: press your feet and notice the floor.",
  "I'll celebrate micro-wins with you all day long.",
  "Your heart is allowed to be full and tired at once.",
  "We can leave this screen softer than we found it.",
] as const;

export const pickRandomBuddyMessage = (excludeIndex?: number): number => {
  if (BUDDY_MESSAGES.length <= 1) return 0;
  let next = Math.floor(Math.random() * BUDDY_MESSAGES.length);
  while (next === excludeIndex) {
    next = Math.floor(Math.random() * BUDDY_MESSAGES.length);
  }
  return next;
};
